export const showSuccessMsg = (message, options = {
    positionClass: 'toast-bottom-full-width',
  }) => toastr.success(message, options);


// WEBPACK FOOTER //
// ./src/Common/SuccessMsg.js